/**
 * Helper to set refetch intervals which will be immediate when testing.
 * @param {Number} ms
 * @returns {Number}
 */
export const setRefetchInterval = ms => {
  if (process?.env?.NODE_ENV === 'test') return 1;
  return ms;
};
